export default {
  readMore: {
    id: 'rm_metal_impact_read_more',
    defaultMessage: 'Read more',
  },
  readLess: {
    id: 'rm_metal_impact_read_less',
    defaultMessage: 'Read less',
  },
  notAssessed: {
    id: 'rm_metal_score_not_assessed',
    defaultMessage: 'Not assessed',
  },
} as const
